import { render, staticRenderFns } from "./CardsetEdit.vue?vue&type=template&id=05187f52&scoped=true&"
import script from "./CardsetEdit.vue?vue&type=script&lang=js&"
export * from "./CardsetEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05187f52",
  null
  
)

export default component.exports